import { activeSlideIndex } from '@ad-rendering/groundcontrol-legacy/tag/models/ad-experiences/carousel 2/carousel';
import { useButler, useEnhancement } from '@ad-rendering/groundcontrol-legacy/tag/models/ad-experiences/hooks';
import { CreativeType } from '@ad-rendering/groundcontrol-legacy/tag/models/common/common';
import { BannerHeadlinePayload, OutstreamHeadlinePayload } from '@sharethrough/groundcontrol-enhancement-flush';
import { h, FunctionalComponent } from 'preact';
import './description.scss';
import { usePublisherStyling } from '../../../../publisher-styling/hook';
import { publisherStyles } from '../../../../publisher-styling/helper/publisherStyles';

const Description: FunctionalComponent = () => {
  const butlerResponse = useButler();
  if (!butlerResponse) return null;

  const { enhancement } = useEnhancement<BannerHeadlinePayload | OutstreamHeadlinePayload>();
  const butlerResponseDescription = enhancement?.payload.description || butlerResponse.creative.description;

  const slides = butlerResponse.creative.slides || [];
  const isIsi = !!butlerResponse.creative.isi?.text;

  const description =
    butlerResponse.creative.action === CreativeType.Carousel
      ? slides[activeSlideIndex.value].description
      : butlerResponseDescription;

  if (butlerResponse.creative.behaviors.shouldHideDescription || isIsi || !description) return null;

  const { styles } = usePublisherStyling();

  const { placement } = butlerResponse;
  const publisherStyle = `${placement.publisherKey}_${placement.domain}`;

  const fontStyle = styles?.description?.font?.toStyle();
  const backgroundStyle = styles?.description?.background?.toStyle();

  const arrayClassName = [
    'str-description',
    ...(!!publisherStyles[publisherStyle] ? ['str-enhanced-description'] : [])
  ];
  return (
    <div className={arrayClassName.join(' ')} style={{ ...fontStyle, ...backgroundStyle }}>
      {description}
    </div>
  );
};

export default Description;
